import { getIconsByState } from './get-icon-by-state';

export const StateIcon = ({ state }: { state: number }) => {
  return (
    <div
      style={{
        top: 0,
        right: 0,
        position: 'absolute',
      }}
    >
      {getIconsByState(state)}
    </div>
  );
};
